import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-screen flex items-center justify-center px-6" data-testid="not-found">
      <div className="text-center">
        <p className="eyebrow">404</p>
        <h1 className="display-1 mt-6">Page <span className="italic text-gold">not found</span>.</h1>
        <p className="mt-6 text-muted-foreground">The page you're looking for has moved or no longer exists.</p>
        <Link to="/" className="btn-gold mt-10 inline-flex">Return Home</Link>
      </div>
    </section>
  );
}
